import { getAccessToken } from "./auth";

const BASE = import.meta.env.VITE_OCEAN_SYNC_URL ?? "http://localhost:3100";

export class ApiError extends Error {
  constructor(public status: number, message: string, public body?: unknown) {
    super(message);
  }
}

async function request(path: string, init: RequestInit): Promise<Response> {
  const token = await getAccessToken();
  const headers = new Headers(init.headers);
  if (init.body !== undefined && init.body !== null) {
    headers.set("Content-Type", "application/json");
  }
  if (token) headers.set("Authorization", `Bearer ${token}`);

  const res = await fetch(`${BASE}/api/v1${path}`, { ...init, headers });

  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    const msg = (body as { error?: { message?: string } })?.error?.message ?? res.statusText;
    throw new ApiError(res.status, msg, body);
  }

  return res;
}

export async function api<T>(
  path: string,
  init: RequestInit = {},
): Promise<T> {
  const res = await request(path, init);
  if (res.status === 204) {
    throw new ApiError(
      204,
      `Unexpected 204 No Content for ${path} — use apiVoid() for endpoints without a body`,
    );
  }
  return res.json() as Promise<T>;
}

export async function apiVoid(path: string, init: RequestInit = {}): Promise<void> {
  await request(path, init);
}
